import React from 'react';
import './AppRedirectBar.css';
import { RxCross2 } from "react-icons/rx";

const AppRedirectBar = ({ onOpenApp, onContinue }) => {
  return (
    <div className="app-redirect-bar">
      <div className="app-redirect-bar__text">
        <button onClick={onContinue}><RxCross2 /></button>
      <div className="app-redirect-bar__text">
        Use the Partywitty app
      </div>
      </div>
      <div className="app-redirect-bar__buttons">
        <button onClick={onOpenApp}>Continue</button>
      </div>
    </div>
  );
};

export default AppRedirectBar;
